module.exports = __webpack_public_path__ + "img/amoney.8d851629.svg";